<section class="notification-center" aria-label="Notificaciones">
  @for (message of messages(); track message.id) {
  <article
    class="notification"
    [class.notification--success]="message.tone === 'success'"
    [class.notification--error]="message.tone === 'error'"
    [class.notification--warning]="message.tone === 'warning'"
    [class.notification--info]="message.tone === 'info'"
    [attr.role]="message.tone === 'error' ? 'alert' : 'status'"
    [attr.aria-live]="message.tone === 'error' ? 'assertive' : 'polite'"
  >
    <mat-icon class="notification__icon" aria-hidden="true">{{ iconFor(message.tone) }}</mat-icon>
    <p class="notification__text">{{ message.text }}</p>
    <button
      class="notification__close"
      type="button"
      aria-label="Cerrar notificación"
      (click)="dismiss(message.id)"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </article>
  }
</section>

@if (confirmation(); as dialog) {
<div class="confirmation-backdrop">
  <button
    class="confirmation-backdrop__dismiss"
    type="button"
    aria-label="Cerrar confirmación"
    (click)="answerConfirmation(false)"
  ></button>
  <section
    class="confirmation-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="confirmation-title"
    aria-describedby="confirmation-message"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (keydown.escape)="answerConfirmation(false)"
  >
    <span class="confirmation-dialog__icon" aria-hidden="true">
      <mat-icon>priority_high</mat-icon>
    </span>
    <h2 id="confirmation-title">{{ dialog.title }}</h2>
    <p id="confirmation-message">{{ dialog.message }}</p>
    <footer class="confirmation-dialog__actions">
      <button
        class="confirmation-dialog__button confirmation-dialog__button--cancel"
        type="button"
        (click)="answerConfirmation(false)"
      >
        {{ dialog.cancelLabel }}
      </button>
      <button
        class="confirmation-dialog__button confirmation-dialog__button--confirm"
        type="button"
        (click)="answerConfirmation(true)"
      >
        {{ dialog.confirmLabel }}
      </button>
    </footer>
  </section>
</div>
}
